module.exports = __webpack_public_path__ + "img/home.6e8c5a58.svg";